// Accounting Categories with Nominal Codes
// Used for purchase items categorization
// The code is stored in the database, but the name is displayed to users

export const ACCOUNTING_CATEGORIES = [
  { code: '6201', name: 'Advertising' },
  { code: '7601', name: 'Audit and Accountancy Fees' },
  { code: '7901', name: 'Bank Charges' },
  { code: '7900', name: 'Bank Interest Paid' },
  { code: '7505', name: 'Books, Magazines etc.' },
  { code: '7503', name: 'Broadband Internet and Fax' },
  { code: '12', name: 'Capital Expenditure [Asset]' },
  { code: '7401', name: 'Car and Van Hire' },
  { code: '5100', name: 'Carriage' },
  { code: '7801', name: 'Cleaning' },
  { code: '5201', name: 'Closing Stock' },
  { code: '8202', name: 'Clothing Costs' },
  { code: '7602', name: 'Consultancy Fees' },
  { code: '6001', name: 'Cost of Sales Labour' },
  { code: '7905', name: 'Credit Charges' },
  { code: '7902', name: 'Currency Charges' },
  { code: '7002', name: 'Directors Remuneration' },
  { code: '5009', name: 'Discounts Taken' },
  { code: '8200', name: 'Donations' },
  { code: '7200', name: 'Electricity' },
  { code: '7700', name: 'Equipment Hire' },
  { code: '10', name: 'Freehold Property [Asset]' },
  { code: '7300', name: 'Fuel and Oil (MOTOR)' },
  { code: '40', name: 'Furniture and Fixtures [Asset]' },
  { code: '7201', name: 'Gas' },
  { code: '5000', name: 'General Purchases' },
  { code: '7103', name: 'General Rates' },
  { code: '6202', name: 'Gifts and Samples' },
  { code: '7904', name: 'H.P. Interest' },
  { code: '7506', name: 'Hosting Fees and IT Consumables' },
  { code: '7402', name: 'Hotels' },
  { code: '5101', name: 'Import Duty' },
  { code: '8204', name: 'Insurance' },
  { code: '7802', name: 'Laundry' },
  { code: '11', name: 'Leasehold Property [Asset]' },
  { code: '7600', name: 'Legal Fees' },
  { code: '7302', name: 'Licences' },
  { code: '7903', name: 'Loan Interest Paid' },
  { code: '6200', name: 'Marketing and Sales Promotions' },
  { code: '5001', name: 'Materials Imported' },
  { code: '6900', name: 'Miscellaneous Expenses' },
  { code: '7304', name: 'Miscellaneous Motor Expenses' },
  { code: '5002', name: 'Miscellaneous Purchases' },
  { code: '50', name: 'Motor Vehicles [Asset]' },
  { code: '30', name: 'Office Equipment [Asset]' },
  { code: '7701', name: 'Office Machine Maintenance' },
  { code: '7202', name: 'Oil' },
  { code: '5200', name: 'Opening Stock' },
  { code: '7203', name: 'Other Heating Costs' },
  { code: '7404', name: 'Overseas Entertainment' },
  { code: '7405', name: 'Overseas Travelling' },
  { code: '6203', name: 'P.R. (Literature & Brochures)' },
  { code: '5003', name: 'Packaging' },
  { code: '20', name: 'Plant and Machinery [Asset]' },
  { code: '7501', name: 'Postage and Carriage' },
  { code: '7803', name: 'Premises Expenses' },
  { code: '7104', name: 'Premises Insurance' },
  { code: '7500', name: 'Printing' },
  { code: '6000', name: 'Productive Labour' },
  { code: '7603', name: 'Professional Fees' },
  { code: '7008', name: 'Recruitment Expenses' },
  { code: '8205', name: 'Refreshments / Staff Welfare' },
  { code: '7100', name: 'Rent' },
  { code: '7800', name: 'Repairs and Renewals' },
  { code: '7301', name: 'Repairs and Servicing (MOTOR)' },
  { code: '6100', name: 'Sales Commissions' },
  { code: '7504', name: 'Stationery' },
  { code: '1001', name: 'Stock [Asset]' },
  { code: '6002', name: 'Sub-Contractors' },
  { code: '8201', name: 'Subscriptions' },
  { code: '7406', name: 'Subsistence' },
  { code: '7502', name: 'Telephone and Mobile Charges' },
  { code: '8203', name: 'Training Costs' },
  { code: '5102', name: 'Transport Insurance' },
  { code: '7400', name: 'Travelling' },
  { code: '7403', name: 'U.K. Entertainment' },
  { code: '7850', name: 'Use of home as office' },
  { code: '7303', name: 'Vehicle Insurance' },
  { code: '7102', name: 'Water Rates' },
];

// Helper function to get category name by code
export const getCategoryName = (code) => {
  const category = ACCOUNTING_CATEGORIES.find(cat => cat.code === code);
  return category ? category.name : code || '';
};

// Helper function to get category code by name
export const getCategoryCode = (name) => {
  const category = ACCOUNTING_CATEGORIES.find(cat => cat.name === name);
  return category ? category.code : '';
};

// Sort categories by name for display
export const SORTED_CATEGORIES = [...ACCOUNTING_CATEGORIES].sort((a, b) => 
  a.name.localeCompare(b.name)
);

